import styled from 'styled-components';
import colors from '../../../assets/colors';

const Cat = styled.div`
  margin-bottom: 20px;
  background-color: ${colors.white};
  border-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  -webkit-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  -moz-box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
  box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);

  .top {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
      padding-right: 10px;
      font-size: 1.2rem;
      text-decoration: ${props => (props.visible ? 'none' : 'line-through')};
      color: ${props => (props.visible ? '#000' : '#CCC')};
    }

    button {
      width: 100px;
      min-width: 100px;
      padding: 8px 0;
      background: ${colors.primary};
      background: linear-gradient(180deg, rgba(55,205,63,1) 0%, rgba(41,157,44,1) 100%);
      border: none;
      border-radius: 100px;
      text-transform: uppercase;
      font-size: 0.9rem;
      font-weight: 600;
      letter-spacing: -0.3px;
      color: ${colors.white};
      font-family: 'Open Sans', sans-serif;
      outline: none;
      cursor: pointer;

      :hover { opacity: .9 }
    }
  }

  .not-found {
    border-top: 1px solid #F1F1F1;
    padding: 20px;
    font-size: 0.9rem;
    letter-spacing: -0.5px;
    color: #999;
    text-align:center;
  }

  .table-lg {
    width: 100%;

    thead {
      background-color: #F1F1F1;

      th {
        padding: 8px 10px;
        font-size: 0.9rem;
        font-weight: 600;
        letter-spacing: -0.5px;
        color: #999;
        text-transform: uppercase;

        :first-child { padding-left: 20px; }
        :last-child { padding-left: 20px }
      }
    }

    tbody {
      td {
        :first-child { padding-left: 8px; text-align: center; }
        :last-child { padding-left: 20px }
      }
    }
  }

  .table-sm { display: none }

  .footer {
    border-top: 1px solid #F1F1F1;
    padding: 20px;

    button {
      background: none;
      border: none;
      font-family: 'Open Sans', sans-serif;
      font-size: 0.9rem;
      color: ${colors.primary};
      padding: 5px;
      cursor: pointer;

      .fa { margin-right: 8px; margin-bottom: -2px; };
      :hover { opacity: .9; }
    }
  }

  @media screen and (max-width: 767px) {
    .table-lg { display: none; }
    .table-sm { display: block; padding: 0 20px; }
  }
`;

export default Cat;
